import React from 'react';
import {useParams} from 'react-router';

import {Card, CardContent} from '@design-system';

import useCategoriesWithActions from '../Queries/useCategoriesWithActions';
import GlossaryAnnotatedTextNew from '../Glossary/GlossaryAnnotatedTextNew';
import ShareButton from '../Shared/ShareResource/ShareButton';
import {findByRouteKey, useCanonicalRouteParams} from '../Util/routeIdentifier';
import {ResourceNotice, ResourceQueryState} from './LoadingCard';
import {RESOURCE_TITLE_CLASSES, ResourceBreadcrumbs, ResourceExternalLink} from './ProCategories';

const ProViewAction = () => {
  const {category: categoryKey, action: actionKey} = useParams();
  const {data: categories, error, refetch} = useCategoriesWithActions();
  // Each found by its slug, or by the numeric id of an address from before COM-477; an
  // action is only ever found in its own category. One replace puts both slugs in the
  // address, whichever segments held an id, once both records are found.
  const category = findByRouteKey(categories, categoryKey);
  const action = findByRouteKey(category?.uniqueKeyActions, actionKey);
  useCanonicalRouteParams(
    {category: category?.slug, action: action?.slug},
    {resource: 'key-action'}
  );

  return (
    <div data-testid="pro-view-action">
      <ResourceBreadcrumbs
        items={[
          {label: 'Home', to: '/dashboard'},
          {label: 'Parents', to: '/parent-categories'},
          ...(category
            ? [
                {
                  label: category.name,
                  to: `/parent-categories/${encodeURIComponent(category.slug)}`,
                },
              ]
            : []),
          ...(action ? [{label: action.name}] : []),
        ]}
      />
      <div className="mb-6 flex flex-wrap items-start justify-between gap-4">
        <h1 className={`flex-1 ${RESOURCE_TITLE_CLASSES}`}>{action?.name ?? 'Parents'}</h1>
        {action ? (
          // COM-165: a Professional shares a parent action as its transition category.
          <ShareButton
            resourceType="transition_category"
            resourceId={category.id}
            resourceSlug={category.slug}
            resourceName={category.name}
          />
        ) : null}
      </div>
      <ResourceQueryState
        data={categories}
        error={error}
        refetch={refetch}
        label="parent resources">
        {action ? (
          <Card>
            <CardContent className="p-6">
              {action.description ? (
                <div className="break-words">
                  <GlossaryAnnotatedTextNew text={action.description} />
                </div>
              ) : null}
              {action.key_action_links?.length ? (
                <ul className="m-0 mt-4 flex list-none flex-col gap-1 p-0">
                  {action.key_action_links.map((link) => (
                    <li key={`action-${link.id}`}>
                      <ResourceExternalLink href={link.url}>{link.title}</ResourceExternalLink>
                    </li>
                  ))}
                </ul>
              ) : null}
            </CardContent>
          </Card>
        ) : (
          <ResourceNotice>Resource not found.</ResourceNotice>
        )}
      </ResourceQueryState>
    </div>
  );
};

export default ProViewAction;
